if (!customElements.get('fw-hero-film')) {
  customElements.define('fw-hero-film', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.video = this.querySelector('.fw-framed-hero__film');
      if (!this.video) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.inView = false;
      this.userPaused = false;
      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.loop = true;
      this.video.controls = false;
      this.video.autoplay = !this.motion.matches;
      if (this.motion.matches) this.video.pause();
      const setLoopSpeed = () => {
        if (!Number.isFinite(this.video.duration) || this.video.duration <= 0) return;
        this.video.defaultPlaybackRate = this.video.duration / 7;
        this.video.playbackRate = this.video.duration / 7;
      };
      this.sync = () => {
        this.toggleAttribute('data-paused', this.video.paused);
        this.setAttribute('aria-label', this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      };
      this.start = () => {
        if (!this.inView || document.hidden || this.userPaused || this.motion.matches) return;
        this.video.play().catch(this.sync);
      };
      this.activate = () => {
        this.userPaused = !this.video.paused;
        if (this.userPaused) this.video.pause();
        else this.video.play().catch(this.sync);
      };
      this.addEventListener('click', this.activate, { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== ' ' && event.key !== 'Enter') return;
        event.preventDefault();
        this.activate();
      }, { signal });
      this.video.addEventListener('loadedmetadata', setLoopSpeed, { signal });
      if (this.video.readyState >= 1) setLoopSpeed();
      this.video.addEventListener('play', this.sync, { signal });
      this.video.addEventListener('pause', this.sync, { signal });
      this.video.addEventListener('canplay', this.start, { signal });
      this.motionChanged = () => {
        this.video.autoplay = !this.motion.matches;
        if (this.motion.matches) this.video.pause();
        else this.start();
      };
      this.motion.addEventListener('change', this.motionChanged);
      document.addEventListener('visibilitychange', () => document.hidden ? this.video.pause() : this.start(), { signal });
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting && entry.intersectionRatio >= .25;
        if (this.inView) this.start();
        else this.video.pause();
      }, { threshold: [0, .25] });
      this.observer.observe(this);
      this.sync();
    }
    disconnectedCallback() {
      this.video?.pause();
      this.observer?.disconnect();
      this.motion?.removeEventListener('change', this.motionChanged);
      this.abort?.abort();
      this.abort = null;
    }
  });
}
